/* Comportamiento de las secciones oe-. Sin dependencias, idempotente y con
   re-init en el editor de temas (shopify:section:load). */
(function () {
  'use strict';

  function once(el, key) {
    if (!el || el.dataset[key] === '1') return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- Barra de anuncio: flechas + rotacion suave ---------- */
  function initAnnouncement(root) {
    root.querySelectorAll('[data-oe-ann]').forEach(function (bar) {
      if (!once(bar, 'oeReady')) return;
      var msgs = bar.querySelectorAll('[data-oe-ann-msg]');
      if (msgs.length < 2) return;
      var i = 0;
      function show(n) {
        i = (n + msgs.length) % msgs.length;
        msgs.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
      }
      var prev = bar.querySelector('[data-oe-ann-prev]');
      var next = bar.querySelector('[data-oe-ann-next]');
      if (prev) prev.addEventListener('click', function () { show(i - 1); });
      if (next) next.addEventListener('click', function () { show(i + 1); });
      setInterval(function () { if (!document.hidden) show(i + 1); }, 3000);
    });
  }

  /* ---------- Tarjetas del metodo: inclinacion 3D segun el cursor ---------- */
  function initTilt(root) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    root.querySelectorAll('.oe-met__card').forEach(function (card) {
      if (!once(card, 'oeTilt')) return;
      var inner = card.querySelector('.oe-met__inner');
      if (!inner) return;
      card.addEventListener('pointermove', function (e) {
        var r = inner.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        inner.style.setProperty('--oe-rx', ((0.5 - y) * 9).toFixed(2) + 'deg');
        inner.style.setProperty('--oe-ry', ((x - 0.5) * 11).toFixed(2) + 'deg');
        inner.style.setProperty('--oe-mx', (x * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', function () {
        inner.style.removeProperty('--oe-rx');
        inner.style.removeProperty('--oe-ry');
        inner.style.removeProperty('--oe-mx');
      });
    });
  }

  /* ---------- Carrusel con scroll nativo, flechas y puntos ---------- */
  function initCarousels(root) {
    root.querySelectorAll('[data-oe-carousel]').forEach(function (c) {
      if (!once(c, 'oeReady')) return;
      var track = c.querySelector('[data-oe-track]');
      var slides = track ? track.children : [];
      var dots = c.querySelectorAll('[data-oe-dot]');
      if (!track || !slides.length) return;

      function step() {
        var s = slides[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return s + gap;
      }
      function current() {
        return Math.round(track.scrollLeft / step());
      }
      function go(n) {
        track.scrollTo({ left: Math.max(0, n) * step(), behavior: 'smooth' });
      }
      var prev = c.querySelector('[data-oe-prev]');
      var next = c.querySelector('[data-oe-next]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { go(k); });
      });

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var n = current();
          dots.forEach(function (d, k) {
            d.classList.toggle('is-active', k === n);
            d.setAttribute('aria-current', k === n ? 'true' : 'false');
          });
        });
      }, { passive: true });
    });
  }

  /* ---------- Citas que rotan con flechas y puntos ---------- */
  function initQuotes(root) {
    root.querySelectorAll('[data-oe-quotes]').forEach(function (q) {
      if (!once(q, 'oeReady')) return;
      var items = q.querySelectorAll('[data-oe-quote]');
      var dots = q.querySelectorAll('[data-oe-qdot]');
      if (items.length < 2) return;
      var i = 0;
      function show(n) {
        i = (n + items.length) % items.length;
        items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      var prev = q.querySelector('[data-oe-qprev]');
      var next = q.querySelector('[data-oe-qnext]');
      if (prev) prev.addEventListener('click', function () { show(i - 1); });
      if (next) next.addEventListener('click', function () { show(i + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    });
  }

  /* ---------- Selector de cantidad ---------- */
  function initQty(root) {
    root.querySelectorAll('[data-oe-qty]').forEach(function (box) {
      if (!once(box, 'oeReady')) return;
      var input = box.querySelector('input');
      box.querySelectorAll('[data-oe-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = Math.max(1, v + Number(b.dataset.oeQtyStep));
          input.value = v;
        });
      });
    });
  }

  /* ---------- Boton sticky en el celular ---------- */
  function initSticky(root) {
    root.querySelectorAll('[data-oe-sticky]').forEach(function (bar) {
      if (!once(bar, 'oeReady')) return;
      var target = document.getElementById(bar.dataset.oeStickyFor);
      var hero = document.querySelector('[data-oe-hero]');
      var footer = document.querySelector('[data-oe-footer]');
      if (!('IntersectionObserver' in window)) return;
      var state = { target: false, hero: true, footer: false };
      function render() {
        var show = !state.target && !state.hero && !state.footer;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      }
      function watch(el, key) {
        if (!el) { state[key] = false; return; }
        new IntersectionObserver(function (e) { state[key] = e[0].isIntersecting; render(); }).observe(el);
      }
      watch(target, 'target');
      watch(hero, 'hero');
      watch(footer, 'footer');
      render();
    });
  }

  /* ---------- FAQ: un solo item abierto a la vez ---------- */
  function initFaq(root) {
    root.querySelectorAll('[data-oe-faq]').forEach(function (list) {
      if (!once(list, 'oeReady')) return;
      var items = list.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- Videos: play / pausa ---------- */
  function initVideos(root) {
    root.querySelectorAll('[data-oe-play]').forEach(function (btn) {
      if (!once(btn, 'oeReady')) return;
      var video = btn.parentElement.querySelector('video');
      if (!video) return;
      btn.addEventListener('click', function () {
        if (video.paused) {
          document.querySelectorAll('.oe video').forEach(function (v) { if (v !== video) v.pause(); });
          video.play();
          btn.classList.add('is-playing');
        } else {
          video.pause();
          btn.classList.remove('is-playing');
        }
      });
    });
  }

  function boot(root) {
    var r = root || document;
    initAnnouncement(r);
    initTilt(r);
    initCarousels(r);
    initQuotes(r);
    initQty(r);
    initSticky(r);
    initFaq(r);
    initVideos(r);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
